import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FilterContext } from '../../context/FilterContext';
import { Button } from '../Common/Button';
import ActivityCard from './ActivityCard';
import { clearQueue } from '../../services/travelTimeQueue';
import { PAGE_SIZE, MAX_ACTIVITIES } from '../../hooks/useActivities';
import { trackEvent } from '../../services/analytics';

const GridView = ({ activities, total, onLoadMore, loadingMore }) => {
  const navigate = useNavigate();
  const { filters } = useContext(FilterContext);

  // «Mehr laden» endet bei MAX_ACTIVITIES, auch wenn der Server mehr hätte.
  const remaining = Math.min(total, MAX_ACTIVITIES) - activities.length;
  const nextLoadCount = Math.min(PAGE_SIZE, remaining);
  const limitReached = remaining <= 0 && total > activities.length;

  // Scroll-Position nach Rückkehr von Detailseite wiederherstellen.
  // useActivities hat anhand von gridVisibleCount bereits genügend
  // Aktivitäten nachgeladen, bevor diese Komponente mountet.
  useEffect(() => {
    const savedY = sessionStorage.getItem('homeScrollY');
    if (savedY) {
      sessionStorage.removeItem('homeScrollY');
      sessionStorage.removeItem('gridVisibleCount');
      requestAnimationFrame(() => window.scrollTo({ top: parseInt(savedY, 10), behavior: 'instant' }));
    }
  }, []);

  const handleActivityClick = (activity) => {
    clearQueue();
    sessionStorage.setItem('homeScrollY', String(window.scrollY));
    sessionStorage.setItem('gridVisibleCount', String(activities.length));
    // Füge Filterdatum als URL-Parameter hinzu, falls gesetzt
    const params = new URLSearchParams();
    if (filters.departure_date) {
      params.set('date', filters.departure_date);
    }
    if (activity.active_time?.start_time) {
      params.set('time', activity.active_time.start_time);
    }
    const queryString = params.toString();
    navigate(`/activities/${activity.id}${queryString ? '?' + queryString : ''}`);
  };

  return (
    <div className="grid-view-container">
      <div className="grid-view">
        {activities.length === 0 && (
          <div style={{ padding: '40px', textAlign: 'center', color: '#666' }}>
            Keine Aktivitäten gefunden
          </div>
        )}
        {/* Aktivitäten-Karten */}
        {activities.map((activity, index) => (
          <ActivityCard
            key={`${activity.id}_${index}`}
            activity={activity}
            onActivityClick={handleActivityClick}
          />
        ))}
      </div>

      {/* Mehr laden – holt die nächste Seite vom Server */}
      {remaining > 0 && (
        <div className="load-more-container">
          <Button
            className="load-more-button"
            onClick={() => {
              trackEvent('load-more', { page: Math.ceil(activities.length / PAGE_SIZE) + 1 });
              onLoadMore();
            }}
            disabled={loadingMore}
            variant="outline"
            style={{ padding: '8px 16px' }}
          >
            {loadingMore ? 'Lädt…' : `Mehr laden (${nextLoadCount})`}
          </Button>
        </div>
      )}
      {limitReached && (
        <div className="load-more-container" style={{ padding: '8px 16px', textAlign: 'center', color: '#666' }}>
          Es werden höchstens {MAX_ACTIVITIES} Aktivitäten angezeigt. Bitte verfeinern Sie die Filter.
        </div>
      )}
    </div>
  );
};

export default GridView;
